import { useLocation } from 'react-router-dom';
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { InboundContext } from '../../context/InboundContext';
import { Button, Heading, Text } from '../../components/styledComponents';
import { FormGroup, Logo } from '../../components/common';
import styles from '../../styles/forgotPassword.module.css';
import { resetPassword } from '../../services/dashboard.service';
import { setStorage } from '../../utils/auth-utils';

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [resetDone, setResetDone] = useState(false);
  const { inboundData } = useContext(InboundContext);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const forgotPasswordId: string = queryParams.get('forgotPasswordId') || '';
  const token: string = queryParams.get('token') || '';
  const handleResetPassword = async (e: any) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setErrorMessage('Your new password & confirm password is not matching!');
    } else {
      const body = { password: newPassword, confirmPassword };
      setDisableSubmitButton(true);
      const response = await resetPassword(body, forgotPasswordId, token);
      if (response.status) {
        setDisableSubmitButton(false);
        setResetDone(true);
        toast.success('Password Reset Successfully, You will be logged in automatically!');
        setStorage('token', response.data.accessToken);
        setTimeout(() => {
          window.location.reload();
          setDisableSubmitButton(false);
        }, 2000);
      } else {
        setErrorMessage(response?.data?.message || response?.message || 'Unable to reset password!');
        setDisableSubmitButton(false);
      }
    }
    setDisableSubmitButton(false);
  };

  return (
    <div className={styles.forgetPasswordMainDiv}>
      <div className={styles.forgotPasswordForm}>
        {inboundData?.landingPage?.images?.logo ? (
          <Logo logoUrl={inboundData?.landingPage?.images?.logo} />
        ) : (
          <Logo logoUrl="https://saral-docs-prod.s3.amazonaws.com/Saral+Black+Logo.svg" />
        )}
        {!resetDone ? (
          <div style={{ width: '80%' }}>
            <Heading as="h2" fontSize="20px" textAlign="center" className={styles.firstHeading}>
              Set New Password
            </Heading>
            <Text textAlign="center" className={styles.secondHeading}>
              Create a new password below
            </Text>
            <form onSubmit={handleResetPassword}>
              <FormGroup
                id="newPassword"
                name="newPassword"
                type="password"
                label="New Password"
                placeholder="Enter your new Password"
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value?.trim());
                  setErrorMessage('');
                }}
              />
              <FormGroup
                id="confirmPassword"
                name="confirmPassword"
                type="text"
                label="Confirm Password"
                placeholder="Re-enter your new Password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value?.trim());
                  setErrorMessage('');
                }}
              />
              <div className={styles.labelDiv}>{errorMessage && <Text color="#e64848">{errorMessage}</Text>}</div>
              <Button
                bgColor="#7357e9"
                width="100%"
                disabled={!newPassword || !confirmPassword || confirmPassword !== newPassword || disableSubmitButton}
                type="submit"
              >
                Reset Password
              </Button>
            </form>
          </div>
        ) : (
          <div>
            <Heading as="h2" fontSize="20px" textAlign="center" className={styles.firstHeading}>
              Password Reset Successfully
            </Heading>
            <Text textAlign="center" className={styles.secondHeading}>
              Your password has been successfully reset. You will be logged in automatically!.
            </Text>
          </div>
        )}
      </div>
    </div>
  );
}
